module.exports = __webpack_public_path__ + "static/media/images.25b22228.png";